import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import AddNewEntryModal from "../components/AddNewEntryModal";
import Edit from "../assets/svgIcons/FormEdit.svg";
import { displayToast } from "../utils/Toast";
import { useErrorHandler } from "../services/ErrorHandler";
import { useSalesFormStore } from "../services/useSalesFormStore";
import { fetchCustomerOrVendor } from "../apis/transaction";
import "../styles/components/BuyerDetails.css";

const ProductDetails = ({
  tab,
  company,
  isEditMode,
  productData = {},
  isFromWO,
  customerName,
  workOrderNo,
}) => {
  const { category } = useParams();
  const navigate = useNavigate();
  const [companies, setCompanies] = useState([]);
  const { handleErrorResponse } = useErrorHandler();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const setCustomerDetails = useSalesFormStore(
    (state) => state.setCustomerDetails,
  );
  const formData = useSalesFormStore((state) => state.formData);

  useEffect(() => {
    const initialDetails = {};
    if (company) {
      initialDetails.company_name =
        company.display_name || company.company_name;
      initialDetails.company_phone = company.contact || company.company_phone;
      initialDetails.company_address =
        company.address || company.delivery_address;
      initialDetails.company_gst_no =
        company.gstno || company.gst_no || company.company_gst_no;
      initialDetails.pincode = company.pincode;
      initialDetails.country = company.country;
      initialDetails.delivery_address =
        company.delivery_address || company.address;
      initialDetails.company_id = company.tran_id;
    }
    setCustomerDetails(initialDetails);
  }, []);

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleSubmitModal = (formData) => {
    setCustomerDetails(formData);
    setIsModalOpen(false);
  };

  const handleAddNewItem = () => {
    setIsModalOpen(true);
  };

  const handleCompanySelect = (company) => {
    navigate(`/${tab}/${category}/transactions`, {
      state: { company },
    });
    setIsModalOpen(false);
  };

  const fetchCustomerOrVendorData = async () => {
    const type = "customer";
    const response = await fetchCustomerOrVendor({ type });
    if (response.description) {
      handleErrorResponse(response.description);
      displayToast(response.description, "error");
    } else {
      setCompanies(response.items);
    }
  };

  useEffect(() => {
    fetchCustomerOrVendorData();
  }, []);

  return (
    <div className="buyer-details-container">
      <div className="buyer-details-header">
        <h3>Product Details</h3>
        {isEditMode && (
          <img
            src={Edit}
            className="buyer-edit-icon"
            onClick={handleAddNewItem}
          />
        )}
      </div>

      <div className="buyer-details-content">
        <div className="detail-row">
          <span className="label">Product Name:</span>
          <span className="value underline">{productData?.name || "-"}</span>
        </div>
        <div className="detail-row">
          <span className="label">Product Description:</span>
          <span className="value">{productData?.description || "-"}</span>
        </div>
        {isFromWO && (
          <div className="detail-row">
            <span className="label">Work Order No:</span>
            <span className="value">{workOrderNo || "-"}</span>
          </div>
        )}
      </div>
      <AddNewEntryModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        onSubmit={handleSubmitModal}
        heading="Please Select Buyer Company"
        placeholder="Company Name"
        options={companies}
        searchPlaceholder="Search Company name"
      />
    </div>
  );
};

export default ProductDetails;
